import React from "react";
import { Box, Flex, Text, Image } from "theme-ui";
import { UseComboboxGetItemPropsOptions } from "downshift";
import { Device } from "../models";
import { IoChevronForward } from "react-icons/io5";

interface ListItemProps {
  getItemProps: (options: UseComboboxGetItemPropsOptions<Device>) => object;
  item: Device;
  index: number;
  highlightedIndex: Number;
  onClick: (device: Device) => void;
}

export const ListItem: React.FunctionComponent<ListItemProps> = ({
  getItemProps,
  item,
  index,
  highlightedIndex,
  onClick,
}) => {
  return (
    <li
      key={`${item}${index}`}
      {...getItemProps({ item, index })}
      onClick={() => onClick(item)}
    >
      <Flex
        sx={{
          width: "100%",
          flexDirection: "column",
          bg: highlightedIndex === index ? "surface" : "transparent",
          transition: "background-color 0.12s ease",
          cursor: "pointer",
          ":hover": {
            bg: "surface",
          },
        }}
      >
        <Box
          sx={{
            borderBottom: "1px solid",
            borderColor: "border",
            textAlign: "left",
            py: 3,
            mx: 4,
          }}
        >
          <Flex
            sx={{
              alignItems: "center",
              justifyItems: "stretch",
              width: "full",
              gap: "12px",
            }}
          >
            <Image
              src={item.logo}
              alt={item.name}
              sx={{
                width: 40,
                height: 40,
                borderRadius: 10,
                flexShrink: 0,
                objectFit: "cover",
                bg: "background",
              }}
            />
            <Flex sx={{ flexDirection: "column", flexGrow: 2, minWidth: 0 }}>
              <Text
                sx={{
                  fontSize: 2,
                  fontWeight: "medium",
                  textAlign: "left",
                  color: "text",
                  lineHeight: 1.35,
                }}
              >
                {item.name}
              </Text>
              <Text
                sx={{
                  fontSize: 0,
                  textAlign: "left",
                  color: "textMuted",
                  lineHeight: 1.45,
                  mt: 1,
                }}
              >
                {item.description}
              </Text>
            </Flex>
            <Box
              as={IoChevronForward}
              sx={{ height: 18, width: 18, flexShrink: 0, color: "textMuted" }}
            />
          </Flex>
        </Box>
      </Flex>
    </li>
  );
};
